module.exports = __webpack_public_path__ + "static/media/bapb-small.e42d3a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bapb-small.png
// module id = 496
// module chunks = 0